import { useState, useRef, useEffect } from 'react';
import * as echarts from 'echarts';
import { overview } from "@/apis/discover";
const ResourceTotal = ({setTotal}) => {
	const chartRef = useRef(null);
	// const [total,setTotal]=useState(0)
	const [dataArr, setDataArr] = useState([
		{
			name: "开放数据",
			value: 0,
		},
		{
			name: "开放工具",
			value: 0,
		},
		{
			name: "开放文档",
			value: 0,
		},
		{
			name: "开放应用",
			value: 0
		}
	])
	const overviewData = () => {
		overview().then(res => {
			setDataArr([
				{
					name: "开放数据",
					value: res?.data?.OpenData || 0,
				},
				{
					name: "开放工具",
					value: res?.data?.OpenTools || 0,
				},
				{
					name: "开放文档",
					value: res?.data?.OpenDocs || 0,
				},
				{
					name: "开放应用",
					value: res?.data?.OpenApps || 0
				}
			])

		})
	};
	useEffect(() => {
		overviewData()
	}, [])
	useEffect(() => {
		const chartDom = chartRef.current;
		const myChart = echarts.init(chartDom);
		const total = dataArr.map(item => item.value).reduce((a, b) => a + b)
		setTotal(total || 0)

		const option = {
			legend: {
				type: 'scroll',
				orient: 'vertical',
				right: '0',
				icon: 'square',
				itemWidth: 10,
				itemHeight: 10,
				top: '36%',
				formatter: function (name) {
					let target = 0
					let precent = 0
					for (let i = 0; i < dataArr.length; i++) {
						if (dataArr[i].name === name) {
							target = dataArr[i].value
							precent = ((dataArr[i].value / total) * 100).toFixed(1)
						}
					}
					var arr = [
						'{a|' + name + '}',
						'{b|' + target + '}',
						'{c|条}',
						'{b|' + precent + '}',
						'{c|%}'
					]
					return arr.join('  ')
				},
				textStyle: {
					rich: {
						a: {
							fontSize: 12,
							color: 'rgba(0,0,0,0.7)',
							width: 55
						},
						b: {
							fontSize: 14,
							color: '#000',
							fontFamily: 'DIN-Regular'
						},
						c: {
							fontSize: 10,
							color: 'rgba(0,0,0,0.7)',
							width: 16
						}
					}
				}
			},
			series: [
				{
					name: '',
					type: 'pie',
					radius: '45%',
					center: ['22%', '49%'],
					label: {
						show: false,
						position: 'center',
						formatter: param => {
							const val = ((param.value / total) * 100).toFixed(1)
							const arr = ['{b|' + param.name + '\n}', `{a|${val}}`, `{b|% }`]
							return arr.join(' ')
						},
						color: '#d62293',
						rich: {
							a: {
								fontSize: 16,
								fontFamily: 'DIN-Regular'
							},
							b: {
								fontSize: 14
							}
						}
					},
					emphasis: {
						label: {
							show: true,
							fontSize: 40,
							fontWeight: 'bold'
						}
					},
					labelLine: {
						show: false
					},
					data: dataArr,
					itemStyle: {
						normal: {
							color: function (params) {
								var colorList = [
									['rgba(86,202,247,0.1)', '#3EC4FD'],
									['rgba(104,187,196,0.1)', '#68bbc4 '],
									['rgba(62,137,253,0.1)', '#3E89FD'],
									['rgba(85,62,253,0.1)', '#553EFD']
								]
								var index = params.dataIndex
								return new echarts.graphic.LinearGradient(0, 0, 1, 1, [
									{
										offset: 0,
										color: colorList[index][0]
									},
									{
										offset: 1,
										color: colorList[index][1]
									}
								])
							}
						}
					}
				}
			]
		};
		myChart.setOption(option);
		window.addEventListener('resize', () => {
			myChart && myChart.resize();
		});
		return () => {
			myChart.dispose();
		};
	}, [dataArr]);
	return <div ref={chartRef}>曲线图</div>
}
export default ResourceTotal;